<template>
    <div class="shop-order-list">
        <van-pull-refresh v-model="isLoading"
                          success-text="刷新成功"
                          @refresh="pullDown">
            <van-list v-model="loading"
                      :finished="finished"
                      finished-text="没有更多了~"
                      @load="loadMore"
                      :immediate-check="false">
                <div class="item"
                     v-for="(item, index) in list"
                     :key="index"
                     @click="itemClick(item)">
                    <div class="title">
                        <span class="name">问问甄选</span>
                        <span class="status">{{ item.status | getName(SHOP_ORDER_STATUS)}}</span>
                    </div>
                    <div class="content">
                        <div class="desc">{{ item.orderNumber }}</div>
                        <div class="bottom">
                            <div class="time">
                                时间：<span>{{ item.createDate }}</span>
                            </div>
                            <div class="price">
                                <span>合计：</span>
                                <span class="money">￥{{ item.total }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </van-list>
        </van-pull-refresh>
    </div>
</template>

<script>
import Vue from 'vue';
import { SHOP_ORDER_STATUS } from '@/mixin/global';
import { PullRefresh, List, Icon, Cell, CellGroup } from 'vant';
Vue.use(PullRefresh);
Vue.use(List);
Vue.use(Icon);
Vue.use(CellGroup);
Vue.use(Cell);

import api_sale from '../../services/saleLogin.js';

export default {
    name: 'shoping-order-list',
    data() {
        return {
            SHOP_ORDER_STATUS,
            isLoading: false,
            loading: false,
            page: 1,
            list: [],
            finished: false,
        };
    },
    mounted() {
        this.loadData();
    },
    methods: {
        pullDown() {
            this.page = 1;
            this.list = [];
            this.finished = false;
            this.isLoading = false;
            this.loadData();
        },
        loadData() {
            this.loading = true;
            this.finished = false;

            api_sale
                .getShopOrderList({
                    patientId: this.$store.getters.getUserInfo.patientId,
                })
                .then(
                    (res) => {
                        this.loading = false;
                        let rows = res.data.data || [];
                        this.list.push(...rows);

                        this.finished = true;
                    },
                    (err) => {
                        this.finished = true;
                    }
                );
        },
        loadMore() {
            this.page++;
            this.loadData();
        },
        itemClick(item) {
            this.$router.push({
                path: 'shopping-order-detail',
                query: { orderNumber: item.orderNumber },
            });
        },
    },
};
</script>

<style lang='less'>
@import '../../style/common.less';
.shop-order-list {
    @color-black: rgb(34, 34, 34);
    @color-grey: rgb(153, 153, 153);

    min-height: 100vh;
    background: #f4f4f4;
    .item {
        margin: 15px;
        background: white;
        border-radius: 4px;
        padding: 0 15px;
        .title {
            height: 44px;
            border-bottom: 1px solid #eee;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .name {
                color: @color-black;
                font-weight: bold;
            }
            .status {
                color: #999;
            }
        }
        .content {
            padding: 10px 0 15px;
            .desc {
                color: @color-black;
                margin-bottom: 12px;
            }
            .bottom {
                color: @color-grey;
                display: flex;
                justify-content: space-between;
                align-items: flex-end;
                .money {
                    font-size: 16px;
                    color: @color-primary;
                }
            }
        }
    }
}
</style>